import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { isAdminUser } from '../utils/adminAccess.js';

/**
 * Blocks non-team users from admin-only routes.
 * Team = any Clerk address on @getupgraded.ca or @getupgraded.ai.
 */
export default function TeamAdminRoute({ children, redirectTo = '/grants-section' }) {
  const { user, isLoaded } = useUser();

  if (!isLoaded) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center px-6">
        <div className="animate-pulse space-y-3 w-full max-w-sm">
          <div className="h-4 w-1/3 rounded bg-gray-100" />
          <div className="h-3 w-2/3 rounded bg-gray-100" />
        </div>
      </div>
    );
  }

  if (!isAdminUser(user)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
